import { MergeOrUpdateStateAction } from '@tableau/vizportalclient-common-components';
import _ from 'underscore';

import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { openReactActionDialog } from '~src/commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { GroupSetsErrorCode } from '~src/commonInfra/utils/ErrorCodes';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';

import { getAppStore } from '../../../../bootstrap/redux/store/AppStore';
import { Messages } from '../../../../codegen/Localize';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';
import {
    CreateGroupSetDialogBody,
    CreateGroupSetDialogProps,
    CreateGroupSetDialogState  } from '../../components/CreateGroupSetDialog';
import { createGroupSet } from '../../serverApi/requests/CreateGroupSetRequest';

const initialBodyProps: CreateGroupSetDialogProps = {};

const initialDialogState: CreateGroupSetDialogState = {
    GroupSetGroupSetNameErrorMessage: undefined,
    GroupSetGroupSetNameText: '',
    isGroupSetGroupSetNameTextValid: true,
};

export function isSubmitEnabled(state: CreateGroupSetDialogState): boolean {
    return !_.isEmpty(state.GroupSetGroupSetNameText) && state.isGroupSetGroupSetNameTextValid && !state.GroupSetGroupSetNameErrorMessage;
}

export function showCreateGroupSetDialog(): Promise<IResult> {
    const title = Messages.createGroupSet();
    const actionDisabled = (props: CreateGroupSetDialogProps, state: CreateGroupSetDialogState) => {
        return !isSubmitEnabled(state);
      };

    const dialogInstance = openReactActionDialog<CreateGroupSetDialogProps, CreateGroupSetDialogState, IResult>({
        actionName: Messages.createGroupDialogSubmit(),
        action: createGroupSetAction,
        actionDisabled,
        bodyComponent: CreateGroupSetDialogBody,
        dialogWidth: TabDialogWidth.width650px,
        dismissDialogOnActionFailed: false,
        initialBodyProps,
        initialDialogState,
        title,
    });
    return Promise.resolve(dialogInstance.result);
}

async function createGroupSetAction(
    props: CreateGroupSetDialogProps,
    dialogState: CreateGroupSetDialogState,
    updateDialogState: React.Dispatch<MergeOrUpdateStateAction<CreateGroupSetDialogState>>): Promise<IResult> {
    const { GroupSetGroupSetNameText } = dialogState;
    const result = await createGroupSet(GroupSetGroupSetNameText);
    return notify(updateDialogState, result, GroupSetGroupSetNameText);
}

function notify(
    updateDialogState: React.Dispatch<MergeOrUpdateStateAction<CreateGroupSetDialogState>>,
    result: IResult,
    groupSetName: string) {
    if (!!result.errors && result.errors.length > 0) {
      const errorMsg: string = errorMessageFor(Number(result.errors[0].code), groupSetName);
      if (errorMsg) {
        // update dialog to show error message
        updateDialogState({ GroupSetGroupSetNameErrorMessage: errorMsg, isGroupSetGroupSetNameTextValid: false });
        return Promise.reject();
      } else {
        ToasterService.instance.pop({ type: ToastType.Error, text: Messages.createGroupSetErrorMsg() });
        return Promise.resolve(result);
      }
    } else {
      getAppStore().dispatch(requestSpaceContents());
      ToasterService.instance.pop({ type: ToastType.Success, text: Messages.createGroupSetSuccessMsg() });
      return Promise.resolve(result);
    }
}

function errorMessageFor(errorCode: number, groupSetName: string): string {
    switch (errorCode) {
      case GroupSetsErrorCode.RESOURCE_CONFLICT:
        return Messages.createGroupSetNameExistsErrorMsg();
      case GroupSetsErrorCode.INVALID_NAME:
        return Messages.createGroupSetInvalidNameErrorMsg();
      default:
        return undefined;
    }
}
export const CreateGroupSetDialogAction = {
  notify
};

export type CreateGroupSetDialogAction = typeof CreateGroupSetDialogAction;
